<template>
    <v-bottom-sheet
        id="bottomSheet"
        :class="$vuetify.display.lgAndDown ? 'mx-8' : ''"
        :inset="$vuetify.display.xlAndUp ? true : false"
        persistent
        scrollable
        :no-click-animation="true"
        :attach="true"
        :absolute="false"
        :contained="true"
        :scrim="false"
        :max-height="sheetHeight"
    >
        <v-card flat :max-height="sheetHeight">
            <v-card-item id="top_card" class="px-3">
                <template v-slot:prepend>
                    <v-avatar :color="`${target.data.color}`">
                        <v-icon
                            :icon="target.data.icon"
                            :color="`${target.data.color}-darken-4`"
                        ></v-icon>
                    </v-avatar>
                </template>
                <v-card-title class="headline">
                    {{ `${target?.label} (${target?.id})` }}
                </v-card-title>
                <!-- Default slot-->
                <slot name="default">
                    <p>{{ $t("strings.no-description") }}</p>
                </slot>
            </v-card-item>
            <!--Create a new slot for dragged operator -->
            <v-card-text
                v-for="(item, idx) in operators"
                :key="idx"
                class="px-3"
            >
                <!-- 'Name' is the slot name (eg.: OperatorCreateObject) -->
                <!-- others attributes are passed to the slot as 'data' object -->
                <slot :name="item" :parentContentHeight="contentHeight">
                    {{ item }}
                </slot>
            </v-card-text>

            <v-divider></v-divider>
            <v-card-actions id="bottom_card">
                <v-spacer></v-spacer>
                <slot name="actions">
                    <p>actions slot</p>
                </slot>
            </v-card-actions>
        </v-card>
    </v-bottom-sheet>
</template>

<script>
export default {
    name: "DialogOperatorTemplate",
    props: {
        target: Object,
        operators: Array,
    },
    data() {
        return {
            actionSection: null,
            titleSection: null,
        };
    },
    mounted() {
        this.actionSection =
            document.getElementById("bottom_card")?.offsetHeight;
        this.titleSection = document.getElementById("top_card")?.offsetHeight;
    },
    watch: {
        actionSection(value) {
            this.actionSection = value;
        },
        titleSection(value) {
            this.titleSection = value;
        },
    },

    computed: {
        sheetHeight() {
            return (window.innerHeight * 2) / 3;
        },
        contentHeight() {
            return (
                this.sheetHeight -
                this.actionSection -
                this.titleSection -
                21 - //is the top and bottom padding of v-card-text + 1 for v-divider
                24 //is the default margin-top of the bottom-sheet overalay
            );
        },
    },
};
</script>
